import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import HomePage from "./views/HomePage";
import LoginPage from "./views/LoginPage";
import Portal from "./views/Portal";
import WishPage from "./views/WishPage";
import { getUser } from "./auth/Auth";
import "./App.css";

function App() {
    const [user, setUser] = useState(undefined);

    useEffect(() => {
        getUser()
            .then((data) => setUser(data ?? null))
            .catch(() => setUser(null));
    }, []);

    if (user === undefined) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-pink-50">
                <div className="spinner-border text-orange-500" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <BrowserRouter>
            <div className="min-h-screen bg-gradient-to-br from-orange-50 to-pink-50">
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/login" element={user?.token ? <Navigate to="/portal" replace /> : <LoginPage />}/>
                    <Route path="/portal/*" element={user?.token ? <Portal /> : <Navigate to="/login" replace />} />
                    <Route path="/wish/:token" element={<WishPage />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </div>
        </BrowserRouter>
    );
}

export default App;
